import { API_BASE_URL } from './client';
import { appendTimeRangeToParams } from '../../utils/timeRange';

async function authFetch(keycloak, path, options = {}) {
  if (!keycloak?.authenticated) {
    throw new Error('User is not authenticated');
  }
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${keycloak.token}`,
      ...(options.headers || {}),
    },
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `HTTP ${response.status}`);
  }
  return response;
}

function buildRagParams({
  period,
  timeRange,
  showAll = false,
  assistantId = null,
  collectionId = null,
} = {}) {
  const params = new URLSearchParams();
  if (timeRange) {
    appendTimeRangeToParams(params, timeRange);
  } else {
    params.set('period', period || 'last7days');
  }
  if (showAll) params.append('show_all', 'true');
  if (assistantId) params.append('assistant_id', String(assistantId));
  if (collectionId) params.append('collection_id', String(collectionId));
  return params;
}

export const getRagDrift = async (keycloak, {
  period = 'last7days',
  timeRange = null,
  showAll = false,
  assistantId = null,
} = {}) => {
  const params = buildRagParams({ period, timeRange, showAll, assistantId });
  const res = await authFetch(keycloak, `/statistics/rag/drift?${params}`);
  return res.json();
};

export const getRagTimeseries = async (keycloak, {
  period = 'last7days',
  timeRange = null,
  showAll = false,
  assistantId = null,
} = {}) => {
  const params = buildRagParams({ period, timeRange, showAll, assistantId });
  const res = await authFetch(keycloak, `/statistics/rag/timeseries?${params}`);
  return res.json();
};

export const getRagDistribution = async (keycloak, {
  period = 'last7days',
  timeRange = null,
  showAll = false,
  assistantId = null,
} = {}) => {
  const params = buildRagParams({ period, timeRange, showAll, assistantId });
  const res = await authFetch(keycloak, `/statistics/rag/distribution?${params}`);
  return res.json();
};

export const getJudgeSummary = async (keycloak, {
  period = 'last7days',
  timeRange = null,
  showAll = false,
  assistantId = null,
} = {}) => {
  const params = buildRagParams({ period, timeRange, showAll, assistantId });
  const res = await authFetch(keycloak, `/statistics/rag/judge/summary?${params}`);
  return res.json();
};

export const getJudgeTimeseries = async (keycloak, {
  period = 'last7days',
  timeRange = null,
  showAll = false,
  assistantId = null,
} = {}) => {
  const params = buildRagParams({ period, timeRange, showAll, assistantId });
  const res = await authFetch(keycloak, `/statistics/rag/judge/timeseries?${params}`);
  return res.json();
};
